import { render, staticRenderFns } from "./whiteboard.vue?vue&type=template&id=73a8a5be&scoped=true"
import script from "./whiteboard.vue?vue&type=script&lang=js"
export * from "./whiteboard.vue?vue&type=script&lang=js"
import style0 from "./whiteboard.vue?vue&type=style&index=0&id=73a8a5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a8a5be",
  null
  
)

export default component.exports